/**
 * @copyright Microsoft Corporation. All rights reserved.
 */

import { IDocument, ITileGroup } from '@augloop/types-core';
import { IUserInformation } from '@augloop-types/graph';

/**
 * @codegen
 */
export enum MailboxType {
    UserMailbox = 1,
    GroupMailbox,
    Unknown,
}

/**
 * @codegen
 */
export interface IRecipient {
    a?: string; // address
    n?: string; // name
    t?: MailboxType; // mailbox type
    u?: IUserInformation; // Additional properties of the user
}

/**
 * @codegen
 */
export interface IEnvelope {
    subject?: string;
    to?: IRecipient[];
    user: IRecipient;
    userP2?: IRecipient;
    constraints: string;
}

export interface IMailDocument extends IDocument {
    envelope?: IEnvelope;
}

export interface IMailBody extends ITileGroup {
}
